export const QUESTION_FORMAT = {
  JOB_DESCRIPTION: 'JOB_DESCRIPTION',
  JOB_PREFERRED_STARTS: 'JOB_PREFERRED_STARTS',
  MULTI_SELECT: 'MULTI_SELECT',
  MULTI_SELECT_VISUAL: 'MULTI_SELECT_VISUAL',
  PHOTO_UPLOAD: 'PHOTO_UPLOAD',
  SINGLE_SELECT: 'SINGLE_SELECT',
  SINGLE_SELECT_VISUAL: 'SINGLE_SELECT_VISUAL',
  TEXT: 'TEXT',
} as const;

export const VISUAL_SIZE = {
  SMALL: 'small',
  LARGE: 'large',
} as const;

export type Option = {
  value: string;
  label: string;
  url?: string;
  preSelected?: boolean;
};

export type QuestionFormat =
  (typeof QUESTION_FORMAT)[keyof typeof QUESTION_FORMAT];
export type VisualSize = (typeof VISUAL_SIZE)[keyof typeof VISUAL_SIZE];

export type AnsweredQuestion = {
  questionId: string;
  title: string;
  format: QuestionFormat;
  answers: Answer[];
};

export type Answer = {
  value: string;
  key?: string;
  url?: string;
  id?: string;
  name?: string;
  file?: File;
  pending?: boolean;
  error?: string;
};

export const ANSWER_TYPE = {
  STRING: 'string',
  INTEGER: 'integer',
} as const;

export type AnswerType = (typeof ANSWER_TYPE)[keyof typeof ANSWER_TYPE];

export type Question = {
  questionId: string;
  required: boolean;
  title: string;
  description?: string;
  helpfulText?: string;
  type: AnswerType;
  format: QuestionFormat;
  options: Option[];
  properties: {
    allowOther?: boolean;
    minimum?: number | null;
    maximum?: number | null;
    otherMinCharacter?: number | null;
    otherMaxCharacter?: number | null;
    visualSize?: VisualSize;
  };
};

export type Form = {
  formId: string;
  categoryId: number;
  experimentId?: string;
  experimentName?: string;
  questions?: Question[];
  variant?: string;
};

export type ScreenProps = Question & {
  savedAnswer?: AnsweredQuestion;
  onNext: (payload: AnsweredQuestion) => void;
  onSkip: () => void;
  editMode?: boolean;
};

export type Category = {
  parent?: {
    id: number;
    name: string;
    label: string;
  };
  highlighted?: boolean;
  vanityCategory?: string;
  id: number;
  name: string;
  label: string;
};

export type RequestOrigin =
  | 'message'
  | 'search'
  | 'profile'
  | 'post-a-job'
  | 'alternative-trades'
  | 'pre-select';

export type Address = {
  postcode: string;
  line1: string;
  line2: string | null;
  line3: string | null;
  city: string;
};
